import { render, staticRenderFns } from "./stacked_column.vue?vue&type=template&id=1093fa4a&"
import script from "./stacked_column.vue?vue&type=script&lang=js&"
export * from "./stacked_column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports